import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Allpagesbanners from '../components/Allpagesbanners';
import { Link } from 'react-router-dom';

function Candidate() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: '',
    position: '',
    subject: '',
    message: '',
    uploadresume: null,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === 'file') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formPayload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formPayload.append(key, value);
    });

    try {
      const res = await fetch('http://jbytam.com/candidate_Mailer.php', {
        method: 'POST',
        body: formPayload,
      });

      const result = await res.json(); // Ensure PHP returns JSON

      if (result.status === 'success') {
        alert('Message sent successfully!');
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          service: '',
          position: '',
          subject: '',
          message: '',
          uploadresume: null,
        });
      } else {
        alert('Error: ' + result.message);
      }
    } catch (error) {
      alert('Failed to send message. Please try again.');
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Header />
      <Allpagesbanners />
      <div className="contact-inner-area sp1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="heading1">
                <h5>Contact Us</h5>
                <h2>Let’s Work Together To Achieve Your Goals</h2>
                <p>
                  At JBY Talent Acquisition & Management Private Limited, we
                  connect talented individuals with outstanding job
                  opportunities.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
              <form className="contact-main-boxarea" onSubmit={handleSubmit}>
                <h3>Send Message</h3>
                <p>We’ll get back to you at the earliest during business hours.</p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-area">
                      <input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-area">
                      <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-area">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-area">
                      <input
                        type="text"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-area">
                      <select
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                       
                        aria-label="Select a service"
                      >
                        <option value="">Select Industry</option>
                        <option value="Information Technology">
                          Information Technology
                        </option>
                        <option value="Pharmaceutical Industry">
                          Pharmaceutical Industry
                        </option>
                        <option value="Non-Banking Financial Companies">
                          Non-Banking Financial Companies
                        </option>
                        <option value="Direct Selling Agents (DSA)">
                          Direct Selling Agents (DSA)
                        </option>
                        <option value="Real Estate Sector">
                          Real Estate Sector
                        </option>
                        <option value="Company Policy Development">
                          Company Policy Development
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-area">
                      <input
                        type="text"
                        name="position"
                        placeholder="Position Apply for"
                        value={formData.position}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-area">
                      <input
                        type="file"
                        name="uploadresume"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-area">
                      <input
                        type="text"
                        name="subject"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-area">
                      <textarea
                        name="message"
                        placeholder="How can we help you?"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-12 text-end">
                    <button type="submit" className="vl-btn1" disabled={isSubmitting}>
                      {isSubmitting ? 'Sending...' : 'Send Now'}{' '}
                      <i className="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Candidate;
